export const version = 'v2.2.4-2178-g4e8c6dcd3'
